import React from 'react';
import {
	AccessorKeyColumnDef,
	getCoreRowModel,
	getSortedRowModel,
	RowData,
	SortingState,
	useReactTable,
	Table as __Table,
} from '@tanstack/react-table';
import { DocumentDataEntry } from './DocumentsOverview';
import { Table as BTable } from 'react-bootstrap';
import TableBody from '../../Components/TableBody';
import TableHeader from '../../Components/TableHeader';

type Props = {
	data: DocumentDataEntry[];
	columns: AccessorKeyColumnDef<DocumentDataEntry, string>[];
	handleRowClick: (row: RowData) => void;
};

const Table = ({ data, columns, handleRowClick }: Props) => {
	const [sorting, setSorting] = React.useState<SortingState>([
		{
			id: 'creationDate',
			desc: true,
		},
	]);

	const table = useReactTable({
		data,
		columns,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		onSortingChange: setSorting,
		state: {
			sorting,
		},
	});

	return (
		<BTable responsive hover size={'l'}>
			<TableHeader table={table as __Table<unknown>} />
			<TableBody table={table as __Table<unknown>} handleRowClick={handleRowClick} />
		</BTable>
	);
};

export default Table;
